<template>
  <b-button-group>
    <b-button
      :disabled="!appLoaded"
      variant="danger"
      @click="$emit('cancel')"
    >
      Discard Changes
    </b-button>

    <b-button
      :disabled="!appLoaded"
      variant="success"
      @click="$emit('save')"
    >
      Save Data
    </b-button>
  </b-button-group>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class DiscardSaveButtons extends Vue {
  get appLoaded () {
    return this.$typedStore.primary.app.appLoaded
  }
}

</script>
